import { LayoutT } from 'business/definitions';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

const deleteChart = async (widgetKey: number): Promise<{ message: string }> => {
    const response = await RQAPICallWithData({
        endpoint: `explore/widget/dashboard/${widgetKey}`,
        method: 'DELETE',
    });
    return response.content;
};

const useDeleteChart = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ widgetKey }: { widgetKey: number; slug: string }) =>
            deleteChart(widgetKey),

        onSuccess: ({ message }, { slug, widgetKey }) => {
            dispatch.vision.notifyUser({
                message,
                snackType: 'success',
            });
            queryClient.setQueryData(
                ['getLayout', slug, ''],
                (layout: LayoutT) => {
                    return {
                        ...layout,
                        widgets: layout.widgets.filter(
                            (widget) => widget.key !== widgetKey,
                        ),
                    };
                },
            );
        },
        meta: { useGlobalOnError: true },
    });
};

export default useDeleteChart;
